<template>
  <ul>
    <UiListItem
      v-for="attribute in filter.attributes"
      :id="`filter-enum-${filter.key}-${attribute.key}`"
      :key="attribute.key"
      tag="li"
      @click="updateValue(filter.key, attribute.key)"
    >
      <div class="flex flex-row gap-1">
        <UiCheckbox
          :id="`filter-enum-${filter.key}-${attribute.key}`"
          :checked="!!value?.includes(attribute.key)"
          :label="attribute.label"
        />
        <UiCounter :id="`filter-enum-${filter.key}-${attribute.key}`" :value="attribute.count ?? 0" />
      </div>
    </UiListItem>
  </ul>
</template>

<script setup lang="ts">
import type { FilterProps } from '~/components/ProductList/Filters/types';

defineProps<FilterProps<string[], string>>();
</script>
